/**
 * Created by JasonChou on 17/6/13.
 */
import * as ActionTypes from '../ActionTypes';

const initialState = {
    userInfo: {},
    list: [],
    circleList: [],
    piclist: [],
    loadMore: true,
    position: 0
};

export default function app(state = initialState, action) {


    switch (action.type) {
        case ActionTypes.LIKE:
            const {userInfo} = state;
            userInfo.like++;
            return Object.assign({}, state, {userInfo});
        case ActionTypes.INIT_USER:
            return {userInfo: action.user, list: [], position: 0};
        case ActionTypes.SAVE_POSITION:
            return Object.assign({}, state, {position: action.position});
        case ActionTypes.SAVE_POSITION_PRODUCT_LIST:
            return Object.assign({}, state, {position_product_list: action.position});
        case ActionTypes.INIT_PRODUCTS:
            return Object.assign({}, state, action.data);
        case ActionTypes.INIT_PRODUCT_LIST_BY_TAG:
            return Object.assign({}, state, action.data);
        case ActionTypes.INIT_CIRCLE:
            return Object.assign({}, state, action.data);
        case ActionTypes.INIT_PICTURE:
            return Object.assign({}, state, action.data);
        case ActionTypes.EXIT_APP:
            return initialState;
    }
    return state;
}



// WEBPACK FOOTER //
// ./src/apps/portfolio/reducers/app.js